var _defs, _tspan, _tspan2, _tspan3, _path, _tspan4, _tspan5, _use, _tspan6, _path2, _use2, _tspan7, _tspan8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFittingScheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "254mm",
    height: "95.262mm",
    viewBox: "0 0 254 95.262",
    id: "svg43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("marker", {
    id: "Arrow2",
    overflow: "visible",
    markerHeight: 5.5999999,
    markerWidth: 7.6999998,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 7.7 5.6"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.7)",
    d: "M -2,-4 9,0 -2,4 c 2,-2.33 2,-5.66 0,-8 z",
    fill: "context-stroke",
    fillRule: "evenodd",
    id: "path2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(15.894 15.972)",
    fill: "#000000",
    fontFamily: "'DejaVu Sans'",
    fontSize: "7.0556px",
    fontWeight: "bold",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 108.18368,
    y: 29.075396,
    strokeWidth: 1.9694,
    "text-align": "center",
    style: {
      lineHeight: 1
    },
    xmlSpace: "preserve",
    id: "text11"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 108.18368,
    y: 29.075396,
    id: "tspan7"
  }, "stochastic")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 108.18368,
    y: 36.130951,
    id: "tspan9"
  }, "lipid profile"))), /*#__PURE__*/React.createElement("text", {
    x: 4.8890967,
    y: 33.099194,
    strokeWidth: 1.9694,
    "text-align": "center",
    style: {
      lineHeight: 0
    },
    xmlSpace: "preserve",
    id: "text15"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 4.8890972,
    y: 33.099194,
    fontSize: "7.0556px",
    strokeWidth: 1.9694,
    id: "tspan13"
  }, "FA profile"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "m6.962 18.709a50.501 22.303 0 0 1 45.332-18.345 50.501 22.303 0 0 1 51.857 14.59",
    fill: "none",
    markerEnd: "url(#Arrow2)",
    stroke: "#000",
    strokeWidth: 1.2673
  })), /*#__PURE__*/React.createElement("text", {
    x: 56.860558,
    y: -9.8577871,
    strokeWidth: 1.2673,
    "text-align": "center",
    style: {
      lineHeight: 1
    },
    xmlSpace: "preserve",
    id: "text22"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 56.860558,
    y: -9.8577871,
    id: "tspan18"
  }, "combinatorial")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 56.860558,
    y: -2.802227,
    id: "tspan20"
  }, "model"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    display: "inline",
    xlinkHref: "#layer1",
    id: "use25",
    transform: "translate(-15.894,-15.972)"
  })), /*#__PURE__*/React.createElement("text", {
    x: 228.15771,
    y: 49.071194,
    fill: "none",
    fontFamily: "'DejaVu Sans'",
    fontSize: "7.0556px",
    fontWeight: "bold",
    strokeWidth: 1.9694,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      lineHeight: 0
    },
    xmlSpace: "preserve",
    id: "text29",
    transform: "translate(-15.894,-15.972)"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 228.15771,
    y: 49.071194,
    fill: "#000000",
    fontSize: "7.0556px",
    strokeWidth: 1.9694,
    id: "tspan27"
  }, "Experiment"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 157.224,46.851 h 35.452",
    markerEnd: "url(#Arrow2)",
    markerStart: "url(#Arrow2)",
    stroke: "#000000",
    strokeWidth: 1.2673,
    id: "path31",
    transform: "translate(-15.894,-15.972)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180,56.696,30.879)",
    xlinkHref: "#path476",
    id: "use33"
  })), /*#__PURE__*/React.createElement("text", {
    x: 72.414665,
    y: 85.540588,
    fill: "#000000",
    fontFamily: "'DejaVu Sans'",
    fontSize: "7.0556px",
    fontWeight: "bold",
    strokeWidth: 1.2673,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      lineHeight: 1
    },
    xmlSpace: "preserve",
    id: "text39",
    transform: "translate(-15.894,-15.972)"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 72.414665,
    y: 85.540588,
    id: "tspan35"
  }, "adjust ")), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 72.414665,
    y: 92.596146,
    id: "tspan37"
  }, "FA profile")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFittingScheme2);
export default __webpack_public_path__ + "static/media/fitting_scheme_2.51b23d3e24fb877332c482f846e58f8a.svg";
export { ForwardRef as ReactComponent };